import styled from "styled-components";

export const StyledMapWrapper = styled.div``;
